var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"my-button-box",attrs:{"type":_vm.nativeType}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }